import { useToast } from '@/components/ui/Toast';
import { MemberPickerDialog } from '@/features/members';
import { getErrorMessage } from '@/utils/errors';
import { fullName } from '@/utils/text';

import { useLinkMachineUser } from '../../hooks/useAttendance';

export interface LinkMemberDialogProps {
  /** The machine user to link; null keeps the dialog closed. */
  user: { id: number; deviceUserId: string; name: string | null } | null;
  onClose: () => void;
}

/**
 * Picks the member a machine user is. Once linked, their visits show on the member's profile and
 * lists show the member's photo and name.
 */
export function LinkMemberDialog({ user, onClose }: LinkMemberDialogProps) {
  const toast = useToast();
  const link = useLinkMachineUser();

  return (
    <MemberPickerDialog
      open={user !== null}
      onClose={onClose}
      title="Link to a member"
      description={
        user
          ? `Who is "${user.name ?? user.deviceUserId}" (machine ID ${user.deviceUserId})?`
          : undefined
      }
      onPick={(member) => {
        if (!user) return;
        link.mutate(
          { userId: user.id, memberId: member.id },
          {
            onSuccess: () => {
              toast.success(
                `Linked to ${fullName(member.firstName, member.lastName)} (${member.memberCode})`,
              );
              onClose();
            },
            onError: (error) => {
              toast.error(getErrorMessage(error));
            },
          },
        );
      }}
    />
  );
}
